/*eslint-disable*/
module.exports = class Soroban {
    static getTypeOfOperation(digit, value) {
        let result = digit + value;
        if (result >= 0 && result <= 9) {
            return Soroban.isBrothersOperation(digit, value) ? 'brothers' : 'simple';
        } else {
            let friend = 10 - Math.abs(value);
            if (value > 0) {
                friend = -friend;
            }
            return Soroban.isBrothersOperation(digit, friend) ? 'brothersAndFriends' : 'friends';
        }
    }

    static isBrothersOperation(digit, value) {
        let result = digit + value;
        return (digit >= 5 && result < 5 || digit < 5 && result >= 5) &&
            (Math.abs(value) >= 1 && Math.abs(value) <= 4);
    }
};
